import { render, staticRenderFns } from "./attend.vue?vue&type=template&id=63b4c63a&"
import script from "./attend.vue?vue&type=script&lang=js&"
export * from "./attend.vue?vue&type=script&lang=js&"
import style0 from "./attend.vue?vue&type=style&index=0&id=63b4c63a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports